import { render, staticRenderFns } from "./FilesSidebarTabApp.vue?vue&type=template&id=48606cb5&scoped=true"
import script from "./FilesSidebarTabApp.vue?vue&type=script&lang=js"
export * from "./FilesSidebarTabApp.vue?vue&type=script&lang=js"
import style0 from "./FilesSidebarTabApp.vue?vue&type=style&index=0&id=48606cb5&prod&lang=css"
import style1 from "./FilesSidebarTabApp.vue?vue&type=style&index=1&id=48606cb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48606cb5",
  null
  
)

export default component.exports